import { Component, Input } from '@angular/core';
import { TransformEmailListItemContract } from '@app-types/api/email';
import { TranslateModule } from '@ngx-translate/core';
import { EmailActionsEnum } from '@app-types/enums/EmailActions';
import { EmailValidationState } from '@app-types/enums/email.validation-state';
import { EmailState } from '@app-types/enums/email-state';
import { ValidateButtonComponent } from '@app-components/email/action-buttons/validate-button/validate-button.component';
import { FinalDeleteButtonComponent } from '@app-components/email/action-buttons/final-delete-button/final-delete-button.component';
import { ReplyButtonComponent } from '@app-components/email/action-buttons/reply-button/reply-button.component';
import { ReplyAllButtonComponent } from '@app-components/email/action-buttons/reply-all-button/reply-all-button.component';
import { ForwardButtonComponent } from '@app-components/email/action-buttons/forward-button/forward-button.component';
import { ForwardAttachmentButtonComponent } from '@app-components/email/action-buttons/forward-attachment-button/forward-attachment-button.component';
import { ReassignButtonComponent } from '@app-components/email/action-buttons/reassign-button/reassign-button.component';
import { GroupsButtonComponent } from '@app-components/email/action-buttons/groups-button/groups-button.component';
import { TagsButtonComponent } from '@app-components/email/action-buttons/tags-button/tags-button.component';
import { SetReadButtonComponent } from '@app-components/email/action-buttons/set-read-button/set-read-button.component';
import { SetUnreadButtonComponent } from '@app-components/email/action-buttons/set-unread-button/set-unread-button.component';
import { MarkAsSpanButtonComponent } from '@app-components/email/action-buttons/mark-as-span-button/mark-as-span-button.component';
import { DeleteButtonComponent } from '@app-components/email/action-buttons/delete-button/delete-button.component';
import { DownloadSingleEmlButtonComponent } from '@app-components/email/action-buttons/download-single-eml-button/download-single-eml-button.component';
import { DownloadEmlButtonComponent } from '@app-components/email/action-buttons/download-eml-button/download-eml-button.component';
import { RestoreButtonComponent } from '@app-components/email/action-buttons/restore-button/restore-button.component';
import { MarkAsNotSpanButtonComponent } from '@app-components/email/action-buttons/mark-as-not-span-button/mark-as-not-span-button.component';
import { MoveToFolderButtonComponent } from '@app-components/email/action-buttons/move-to-folder-button/move-to-folder-button.component';
import { ArchiveButtonComponent } from '@app-components/email/action-buttons/archive-button/archive-button.component';
import { AuditButtonComponent } from '@app-components/email/action-buttons/audit-button/audit-button.component';
import { RetrySendingButtonComponent } from '@app-components/email/action-buttons/retry-sending-button/retry-sending-button.component';
import { MoveToDraftButtonComponent } from '@app-components/email/action-buttons/move-to-draft-button/move-to-draft-button.component';
import { RestoreArchiveButtonComponent } from '@app-components/email/action-buttons/restore-archive-button/restore-archive-button.component';
import { MetaButtonComponent } from '@app-components/email/action-buttons/meta-button/meta-button.component';
import { ActionsService } from '@app-services/emails/button-actions/actions.service';
import { ActionsModalsService } from '@app-services/emails/button-actions/actions-modal.service';
import { ButtonActionsService } from '@app-services/emails/button-actions/button-actions.service';
import { EmailsPageStateService } from '@app-services/emails/emails-page-state.service';
import { ArchivingButtonComponent } from '@app-components/email/action-buttons/archiving-button/archiving-button.component';

@Component({
  selector: 'app-email-action-buttons',
  templateUrl: './email-action-buttons.component.html',
  styleUrls: ['./email-action-buttons.component.scss'],
  imports: [
    TranslateModule,
    ValidateButtonComponent,
    FinalDeleteButtonComponent,
    ReplyButtonComponent,
    ReplyAllButtonComponent,
    ForwardButtonComponent,
    ForwardAttachmentButtonComponent,
    ReassignButtonComponent,
    GroupsButtonComponent,
    TagsButtonComponent,
    SetReadButtonComponent,
    SetUnreadButtonComponent,
    MarkAsSpanButtonComponent,
    DeleteButtonComponent,
    DownloadSingleEmlButtonComponent,
    DownloadEmlButtonComponent,
    RestoreButtonComponent,
    MarkAsNotSpanButtonComponent,
    MoveToFolderButtonComponent,
    ArchiveButtonComponent,
    AuditButtonComponent,
    RetrySendingButtonComponent,
    MoveToDraftButtonComponent,
    RestoreArchiveButtonComponent,
    MetaButtonComponent,
    ArchivingButtonComponent,
  ],
})
export class EmailActionButtonsComponent {
  public actionsModals: ActionsModalsService;
  public actions: ActionsService;

  @Input() email: TransformEmailListItemContract;
  @Input() isMenu = false;

  EmailActionsEnum = EmailActionsEnum;
  EmailValidationState = EmailValidationState;
  EmailState = EmailState;

  constructor(
    protected buttonActionsService: ButtonActionsService,
    protected emailsPageStateService: EmailsPageStateService
  ) {
    this.actionsModals = buttonActionsService.actionsModals;
    this.actions = buttonActionsService.actions;
  }
}
